import {Fragment, useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {notification} from "antd";
import ActionBar from "~/layout/ActionBar";
import {Button, Loading, Modal, Icon} from "~/components";
import {
	contractErrorSelector,
	contractFilterSelector,
	contractItemsSelector,
	contractLoadingSelector,
	contractPaginationSelector,
	contractActions
} from "../contractSlice";
import {
	ContractTable,
	ContractFormAddEdit,
	ContractFormTransfer,
	ContractFormInfo,
	ContractSearchBar,
	ContractSearchMobile,
	ContractFormService,
	ContractFormRevenue,
	ContractFormStatus,
	CustomerFormInfo,
	ContractFormNote
} from "../components";
import {
	apiError,
	strToTime,
	handleRequest,
} from "~/utils";
import {
	useCan,
	useDevice,
	useSocket,
	useGroup
} from "~/hooks";
import {
	contractApi,
	revenueApi,
	serviceApi,
	customerApi
} from "~/api";

import _ from "lodash";
import PromotionForm from "../components/Forms/PromotionForm";

function Contract() {

	const {isMobile} = useDevice();

	const {socket}  = useSocket();

	const can = {
		add: useCan('contractAdd'),
		edit: useCan('contractEdit'),
		transfer: useCan('contractTransfer'),
		delete: useCan('contractDelete'),
		status: useCan('contractStatus'),
		service: useCan('contractService'),
		revenue: useCan('revenueAdd'),
		download: useCan('contractPrint'),
		note: useCan('contractNote'),
		dtlt: useCan('contractDTLT'),
	};

	const dispatch  = useDispatch();

	const items     = useSelector(contractItemsSelector);

	const loading   = useSelector(contractLoadingSelector);

	const error     = useSelector(contractErrorSelector);

	const pagination = useSelector(contractPaginationSelector);

	const filter    = useSelector(contractFilterSelector);

	const listGroup = useGroup();

	const [itemEdit, setItemEdit] = useState({});

	const [contractDownloadUrl, setContractDownloadUrl] = useState('');

	const [dtltLink, setDtltLink] = useState('');

	const [dtltLoading, setDtltLoading] = useState(false);

	const [promotions, setPromotions] = useState([]);

	const [contractPromotions, setContractPromotions] = useState([]);

	//Model
	const [openModal, setOpenModal] = useState({
		addEdit     : false,
		delete      : false,
		transfer    : false,
		info        : false,
		service     : false,
		revenue     : false,
		infoCustomer: false,
		download: false,
		paperStatus: false,
		note: false,
		promotion: false,
	});

	const handleModalOpen = (modal) => {
		openModal[modal] = true;
		setOpenModal({...openModal})
	}

	const handleModalClose = (modal) => {
		openModal[modal] = false;
		setOpenModal({...openModal});
	}

	//Load data
	useEffect(() => {
		handleReLoading()
	}, [filter]);

	//Show Error
	if (error) {
		notification.error({message: 'Lỗi', description: error});
	}

	const handleReLoading = () => {
		dispatch(contractActions.fetchData({
			...filter,
			detail: ['user', 'customer', 'promotion']
		}));
	}

	//Submit
	const handleSaveItem = async (data, isEdit) => {
		let messageAction = 'Thêm mới';
		if(isEdit) {
			if (!itemEdit?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin hợp đồng để cập nhật'});
				return;
			}
			data.id = itemEdit.id;
			messageAction = 'Cập nhật';
		}
		data.promotions = contractPromotions.map(promotion => promotion.id);
		data.signing = strToTime(data.signing);
		let [error, response] = (isEdit) ? await handleRequest(contractApi.update(data)) : await handleRequest(contractApi.add(data));
		let message = apiError(`${messageAction} thông tin hợp đồng thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `${messageAction} thông tin hợp đồng thành công`});
			if(!isEdit)
			{
				/*socket.emit("set-notification-contract", {
					userAvatar: userCurrent.avatar,
					userName: userCurrent.firstname +' '+ userCurrent.lastname,
					code : response.data.code,
					name : response.data.name
				});*/

				dispatch(contractActions.add(response.data));
			}
			else
			{
				setItemEdit(response.data);
				dispatch(contractActions.update(response.data));
			}
			handleModalClose('addEdit')
		}
	}

	//Delete
	const handleDelete = async () => {
		if (!itemEdit?.id)
		{
			notification.error({message: 'Lỗi', description: 'Không có thông tin hợp đồng để xóa'});
			return;
		}
		if (itemEdit.status.key != 'pending')
		{
			notification.error({message: 'Lỗi', description: 'Hợp đồng đã duyệt không thể xóa'});
			return;
		}
		let [error, response] = await handleRequest(contractApi.delete(itemEdit.id));
		let message = apiError(`xóa hợp đồng thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `xóa hợp đồng thành công`});
			dispatch(contractActions.delete(itemEdit.id));
			handleModalClose('delete')
		}
	}

	//transfer
	const handleTransfer = async (data, item) => {
		if (item?.id == 'undefined') {
			notification.error({message: 'Lỗi', description: 'Không có thông tin hợp đồng để cập nhật'});
			return;
		}

		data.id = item.id;

		let [error, response] = await handleRequest(contractApi.transfer(data));

		let message = apiError(`Chuyển nhân viên quản lý hợp đồng không thành công`, error, response);

		if(!message) {
			notification.success({message: 'Thành công', description: `Chuyển nhân viên quản lý hợp đồng thành công`});
			if(response.data?.userId) {
				item.user = response.data.user;
				item.userId = response.data.userId;
				item.groupId = response.data.groupId;
			}
			if(response.data?.userShareId) {
				item.userShare = response.data.userShare;
				item.userShareId = response.data.userShareId;
				item.groupShareId = response.data.groupShareId;
			}
			dispatch(contractActions.update(item));
			handleModalClose('transfer');
		}
	}

	//Service
	const handleService = async (data, item) => {
		if (item?.id == 'undefined') {
			notification.error({message: 'Lỗi', description: 'Không có thông tin hợp đồng để cập nhật'});
			return;
		}
		if (item?.serviceId != 0) {
			notification.error({message: 'Lỗi', description: 'Hợp đồng này đã có dịch vụ'});
			return;
		}

		data.id = item.id;
		data.expired = strToTime(data.expired);
		let [error, response] = await handleRequest(serviceApi.add(data));
		let message = apiError(`Thêm dịch vụ cho hợp đồng không thành công`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `Thêm dịch vụ cho hợp đồng thành công`});
			item.serviceId = response.data.serviceId;
			item.domain = response.data.domain;
			item.expired = response.data.expired;
			dispatch(contractActions.update(item));
			handleModalClose('service')
		}
	}

	//Revenue
	const handleRevenue = async (data, item) => {
		if (item?.id == 'undefined') {
			notification.error({message: 'Lỗi', description: 'Không có thông tin hợp đồng để thêm doanh thu'});
			return;
		}

		data.contractId = item.id;
		data.time = strToTime(data.time);
		let [error, response] = await handleRequest(revenueApi.add(data));
		let message = apiError(`Thêm doanh thu cho hợp đồng không thành công`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `Thêm doanh thu cho hợp đồng thành công`});
			handleModalClose('revenue')
		}
	}

	//status
	const handleStatus = async (status) => {
		if (!itemEdit?.id)
		{
			notification.error({message: 'Lỗi', description: 'Không có thông tin hợp đồng để cập nhật'});
			return;
		}
		let [error, response] = await handleRequest(contractApi.status({ id: itemEdit.id, status}));
		let message = apiError(`Cập nhật trạng thái hợp đồng thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `Cập nhật trạng thái hợp đồng thành công`});
			itemEdit.status = response.data.status;
			setItemEdit(itemEdit);
			dispatch(contractActions.update(itemEdit));
			if(!_.isEmpty(response.data.notification))
			{
				socket.emit("set-notification-user", response.data.notification);
			}
		}
	}

	const handleCustomerStatus = async (item) => {
		if (!item?.id)
		{
			notification.error({message: 'Lỗi', description: 'Không có thông tin khách hàng để cập nhật'});
			return;
		}
		let [error, response] = await handleRequest(customerApi.status({
			id: item.id,
			status: 'confirm',
		}));
		let message = apiError(`Cập nhật trạng thái khách hàng thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `Cập nhật trạng thái khách hàng thành công`});
			let newItem = JSON.parse(JSON.stringify(itemEdit));
			newItem.customer.status = response.data.status;
			dispatch(contractActions.update(newItem));
			handleModalClose('infoCustomer')
		}
	}

	const handleDownload = async (item) => {
		setContractDownloadUrl('');
		handleModalOpen('download');
		if (!item?.id) {
			notification.error({message: 'Lỗi', description: 'Không có thông tin hợp đồng để xuất'});
			return;
		}
		let [error, response] = await handleRequest(contractApi.print(item));
		let message = apiError(`Xuất hợp đồng thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `Xuất hợp đồng thành công`});
			setContractDownloadUrl(response.data.path)
		}
	}

	const handleAddDTLT = async (item) => {
		setDtltLink('');
		setDtltLoading(true);
		handleModalOpen('dtlt');
		if (!item?.id) {
			notification.error({message: 'Lỗi', description: 'Không có thông tin hợp đồng để tạo file'});
			setDtltLoading(false);
			return;
		}
		let [error, response] = await handleRequest(contractApi.addDTLT({id: item.id}));
		let message = apiError(`Tạo file đặc tả lập trình thất bại`, error, response);
		setDtltLoading(false);
		if(!message) {
			notification.success({message: 'Thành công', description: `Tạo file đặc tả lập trình thành công`});
			setDtltLink(response.data.link);
		}
	}

	const handlePaperStatus = async (data, itemsNote, setItemsNote) => {		if (!itemEdit?.id)
		{
			notification.error({message: 'Lỗi', description: 'Không có thông tin hợp đồng để cập nhật'});
			return;
		}

		if(data.status !== itemEdit.paperStatus) {
			let [error, response] = await handleRequest(contractApi.paperStatus({ id: itemEdit.id, status: data.status}));
			let message = apiError(`Cập nhật trạng thái thu hồi hợp đồng thất bại`, error, response);
			if(!message) {
				notification.success({message: 'Thành công', description: `Cập nhật trạng thái thu hồi hợp đồng thành công`});
				itemEdit.paperStatus = response.data.status;
				setItemEdit(itemEdit);
				dispatch(contractActions.update(itemEdit));
				handleModalClose('paperStatus')
			}
		}

		if(data.note.length > 0) {

			let [error, response] = await handleRequest(contractApi.addNote({
				id: itemEdit.id,
				note: data.note
			}));

			let message = apiError(`Cập nhật thông tin hợp đồng thất bại`, error, response);

			if(!message) {
				setItemsNote([
					...itemsNote,
					response.data
				])
			}
		}
	}

	//Search
	const SearchBar = (isMobile) ? ContractSearchMobile : ContractSearchBar;

	const handlePaginationChange = (page) => {
		dispatch(contractActions.setFilter({...filter, page }));
	}

	const handleSearchChange = (newFilter) => {
		dispatch(contractActions.setFilterWithDebounce(newFilter));
	};

	const handleFilterChange = (key, value, reset = false) => {
		let newFilter = {
			...filter,
			page: 1,
		};
		if(reset) {
			newFilter.customerId = '';
			newFilter.status = '';
			newFilter.userId = '';
			newFilter.groupId = '';
			newFilter.service = '';
			newFilter.keyword = '';
		}
		newFilter = {
			...newFilter,
			[key]: value,
			page: 1
		};
		dispatch(contractActions.setFilter(newFilter));
	};

	return (
		<Fragment>
			<ActionBar title={'Hợp đồng'}>
				{can.add && <Button outline leftIcon={Icon.plusCircle} onClick={() => {setItemEdit({});handleModalOpen('addEdit')}}>{ (isMobile) ? '' : 'Thêm mới'}</Button>}
				<Button outline onClick={handleReLoading}>{Icon.reload}</Button>
			</ActionBar>
			<div className="container">
				<div className="content">
					{loading && <Loading/>}
					<SearchBar filter={filter} onSearchChange={handleSearchChange} listGroup={listGroup} onChange={handleFilterChange} />
					{items && <ContractTable
						items={items}
						pagination={pagination}
						onPaginationChange={handlePaginationChange}
						setItemEdit={setItemEdit}
						openModal={handleModalOpen}
						onChangeFilter={handleFilterChange}
						handleDownload={handleDownload}
						handleAddDTLT={handleAddDTLT}
						filter={filter}
						can={can}
					/>}
				</div>
				<Modal zIndex={101} title="Chương trình khuyến mãi" visible={openModal.promotion} onCancel={() => {handleModalClose('promotion')}}>
					<PromotionForm
						openModal={openModal}
						promotions={promotions}
						setPromotions={setPromotions}
						contractPromotions={contractPromotions}
						setContractPromotions={setContractPromotions}
						closeModal={handleModalClose}
					/>
				</Modal>
				{
					(can.delete && itemEdit?.id) && <Modal title="Xóa khách hàng" visible={openModal.delete} onCancel={() => {handleModalClose('delete')}}>
						<p>Bạn muốn xóa hợp đồng <b>{itemEdit?.name}</b>?</p>
						<div className="pd-1 d-flex justify-content-end gap modal-bottom">
							<Button white leftIcon={Icon.close} onClick={() => {handleModalClose('delete')}}> Đóng </Button>
							<Button primary leftIcon={Icon.delete} onClick={handleDelete}> Xóa </Button>
						</div>
					</Modal>
				}
				{
					(can.add || can.edit) && <Modal title="Hợp đồng" visible={openModal.addEdit} onCancel={() => {handleModalClose('addEdit')}}>
						<ContractFormAddEdit
							item={itemEdit}
							onHandleSubmit={handleSaveItem}
							openModal={handleModalOpen}
							contractPromotions={contractPromotions}
							setContractPromotions={setContractPromotions}
						/>
					</Modal>
				}
				{
					(itemEdit?.id) && <Modal zIndex={99} title="Thông tin hợp đồng" size="xl" visible={openModal.info} onCancel={() => {handleModalClose('info')}}>
						<ContractFormInfo item={itemEdit} onClickStatus={handleStatus} modalOpen={handleModalOpen}/>
					</Modal>
				}
				{
					(can.transfer && itemEdit?.id) && <Modal title="Chuyển nhân viên" visible={openModal.transfer} onCancel={() => {handleModalClose('transfer')}}>
						<ContractFormTransfer item={itemEdit} onHandleSubmit={handleTransfer}/>
					</Modal>
				}
				{
					(can.service && itemEdit?.id) && <Modal title="Cộng dịch vụ" visible={openModal.service} onCancel={() => {handleModalClose('service')}}>
						<ContractFormService item={itemEdit} onHandleSubmit={handleService}/>
					</Modal>
				}
				{
					(can.revenue && itemEdit?.id && openModal.revenue) && <Modal title="Thêm doanh thu" visible={openModal.revenue} onCancel={() => {handleModalClose('revenue')}}>
						<ContractFormRevenue item={itemEdit} onHandleSubmit={handleRevenue}/>
					</Modal>
				}
				{
					(itemEdit?.customer && openModal.infoCustomer) && <Modal title="Thông tin khách hàng" visible={openModal.infoCustomer} onCancel={() => {handleModalClose('infoCustomer')}}>
						<CustomerFormInfo item={itemEdit.customer} onClickStatus={handleCustomerStatus}/>
					</Modal>
				}
				{
					(can.download && openModal.download) && <Modal title="Tải hợp đồng" visible={openModal.download} onCancel={() => {handleModalClose('download')}}>
						{
							contractDownloadUrl.length === 0 && <Loading />
						}
						{
							contractDownloadUrl.length !== 0 && <div className="text-center"><Button background green href={contractDownloadUrl} download={true} blue leftIcon={Icon.download} >Tải về</Button></div>
						}
					</Modal>
				}

				{
					(can.status && itemEdit?.id && openModal.paperStatus) && <Modal zIndex={99} title="Trạng thái thu hồi hợp đồng" visible={openModal.paperStatus} onCancel={() => {handleModalClose('paperStatus')}}>
						<ContractFormStatus item={itemEdit} onHandleSubmit={handlePaperStatus}/>
					</Modal>
				}
				{
					(can.note && itemEdit?.id) && <Modal zIndex={99} title="Ghi chú hợp đồng" visible={openModal.note} onCancel={() => {handleModalClose('note')}}>
						<ContractFormNote item={itemEdit} />
					</Modal>
				}
				{
					openModal.dtlt && <Modal title="Tạo file đặc tả lập trình" visible={openModal.dtlt} onCancel={() => {handleModalClose('dtlt')}}>
						{dtltLoading && <Loading />}
						{!dtltLoading && dtltLink && (
							<div className="text-center pd-1">
								<p style={{marginBottom: '12px', wordBreak: 'break-all'}}>
									<a href={dtltLink} target="_blank" rel="noreferrer">{dtltLink}</a>
								</p>
								<div className="d-flex justify-content-center gap">
									<Button background green leftIcon={Icon.copy} onClick={() => {navigator.clipboard.writeText(dtltLink); notification.success({message: 'Đã sao chép link'});}}>Sao chép link</Button>
									<Button background blue leftIcon={Icon.download} href={dtltLink} target="_blank">Mở file</Button>
								</div>
							</div>
						)}
						{!dtltLoading && !dtltLink && (
							<p className="text-center color-grey">Không thể tạo file. Vui lòng thử lại.</p>
						)}
					</Modal>
				}
			</div>
		</Fragment>
	)
}

export default Contract;